module.exports = __webpack_public_path__ + "static/img/Group21705.67bce98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group21705.png
// module id = g8Th
// module chunks = 134